import { render, staticRenderFns } from "./FeriadoSetting.vue?vue&type=template&id=96613822"
import script from "./FeriadoSetting.vue?vue&type=script&lang=js"
export * from "./FeriadoSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports